// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['comissao_avaliacao']



const DEFAULT_URL = '/perfil-empresa'

const perfilEmpresaBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Perfil Empresa',
    to: 'perfil-empresa'
  }
]

export default [
  {
    path: `${DEFAULT_URL}`,
    name: 'perfil-empresa',
    component: () => import('@/views/PerfilEmpresa/PerfilEmpresaListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Perfil Empresa',
      breadcrumb: perfilEmpresaBreadCrumb
    }
  },
  {
    path: `${DEFAULT_URL}/:id/details`,
    name: 'perfilEmpresaDetails',
    component: () => import('@/views/PerfilEmpresa/NovoPerfilEmpresaPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Detalhes',
      breadcrumb: [
        ...perfilEmpresaBreadCrumb,
        {
          label: 'Detalhes do Perfil da Empresa',
          to: 'perfilEmpresaDetails'
        }
      ]
    }
  }
]
